import { render, staticRenderFns } from "./FundraisingPageTopDonations.vue?vue&type=template&id=05314f18&scoped=true&"
import script from "./FundraisingPageTopDonations.vue?vue&type=script&lang=js&"
export * from "./FundraisingPageTopDonations.vue?vue&type=script&lang=js&"
import style0 from "./FundraisingPageTopDonations.vue?vue&type=style&index=0&id=05314f18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05314f18",
  null
  
)

export default component.exports